import React, { Component } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import './style.scss';

export default class PdfModal extends Component {

    render() {
        return (
            <Modal isOpen={this.props.isOpen} centered={true} size="lg">
                <ModalBody>
                    <div className='custom-modal-container'>
                        <div className='custom-modal-header-container'>
                            <span className='custom-header-title'>Pdf</span>
                            <Button onClick={this.onDismiss} className='modal-close-button'>
                                <i className="fa fa-times-circle-o fa-lg modal-close-icon" />
                            </Button>
                        </div>
                        {this.renderFullView()}
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    renderFullView = () => {
        const { base64, label } = this.props.previewPdf;
        return (
            <div className='modal-pdf-container'>
                <iframe src={'data:application/pdf;base64,' + base64} className='full-pdf-dimension' />
                <div className='modal-label-container'>
                    <p className='modal-label' >{label}</p>
                </div>
            </div>
        )
    }

    onPreviewClosed = () => {
        this.props.dismissPreview();
    }

    onDismiss = () => {
        this.props.dismissPreview();
    }
}
